<template>
  <div class="content">
    <grid 
      label='Funding Address'
      :model="model"
      name="" 
      desc="" 
      search
      :views='false'
      :resizing='false'
      layout="frame" 
      :endpoint="api.$.FundingInvoiceAndApSetting.getFundingAddresses" 
      :actions='actions'
	    @editRow="openAddEditAddress($event)"
      @removeRow='removeFundingAddress'
      @removeRows='removeMultipleFundingAddresses'
      remove-many
      fit-columns
      footer
      ref="FundingAddressesGrid">
        <span slot="additionalButtons">
          <ed-button 
            class="btn btn-actionbar" 
            :disabled="disableSingleButton" 
            @click="openAddEditAddress()">
            Add New Address
          </ed-button>
        </span>
    </grid>
    <AddEditFundingAddress
      v-if='showAddEditAddress'
      :model= "fundingAddressModel"
      :showModal= "showAddEditAddress"
      @close="showAddEditAddress = false"
      @save='onSave'
    >
    </AddEditFundingAddress>
     
  </div>

</template>

<script>

import Grid from '@/components/Grid'
import model from './model'
import {edit, remove} from '@/components/Grid/cells/actions'
import AddEditFundingAddress from './AddEditFundingAddress.vue'

export default {
  components: {
    Grid,
    AddEditFundingAddress
  },

  data() {
    return {
      model,
      actions: [edit, remove],
      showAddEditAddress: false,
      fundingAddressModel: {
        newAddress: {},
        edit: false,
        HasAPSettingsByBU: false
      }
    }
  },
  created() {
  },

  methods: {

    async openAddEditAddress(item) {
      let newAddress = {}
      let divisions = []
      let businessUnits = []
      let hasAPSettingsByBU = false
      await this.api.get(this.api.$.FundingInvoiceAndApSetting.hasAPSettingsByBU)
        .then(response => {
          hasAPSettingsByBU = response.data.Data
        })

      if (typeof item !== 'undefined') {
        let data = item.data
        if (hasAPSettingsByBU) {
          await this.api.get(this.api.$.FundingInvoiceAndApSetting.getSelectedBusinessUnits, {
            params: {
              vendorAddressId: item && item.data && item.data.VendorAddressId || 0
            }
          })
          .then(response => {
            businessUnits = response.data.Data
          })
        } else {
          await this.api.get(this.api.$.FundingInvoiceAndApSetting.getSelectedDivisions, {
            params: {
              vendorAddressId: item && item.data && item.data.VendorAddressId || 0
            }
          })
          .then(response => {
            divisions = response.data.Data
          })
        }

        newAddress = {
          VendorAddressId: data.VendorAddressId,
          FundingEntityName: data.Name,
          EntityLegalName: data.EntityLegalName,
          EIN: data.EIN,
          Address: data.Address,
          Address2: data.Address2,
          Country: {
            CountryName: data.Country,
            CountryID: data.CountryId
          },
          City: data.City,
          ZipCode: data.Zip,
          VatId: data.VatNo,
          State: {
            StateID: data.StateId,
            StateName: data.StateName
          },
          CanadaState: {
            StateName: data.StateAndRegion
          },
          Region: data.Region,
          Email: data.Email,
          Divisions: divisions,
          BusinessUnits: businessUnits
        }
        this.fundingAddressModel.edit = true
      } else {
        newAddress = {
          VendorAddressId: 0,
          FundingEntityName: '',
          EntityLegalName: '',
          EIN: '',
          Address: '',
          Address2: '',
          Country: {
            CountryName: '',
            CountryID: 0
          },
          State: {
            StateID: 0,
            StateName: ''
          },
          CanadaState: {
            StateID: 0,
            StateName: ''
          },
          Region: '',
          City: '',
          ZipCode: '',
          VatId: '',
          Email: '',
          Divisions: divisions,
          BusinessUnits: businessUnits
        }
        this.fundingAddressModel.edit = false
      }
      this.fundingAddressModel.newAddress = newAddress
      this.fundingAddressModel.HasAPSettingsByBU = hasAPSettingsByBU

      this.showAddEditAddress = true
    },

    removeFundingAddress(payload, success, fail) {
      var id = +payload.data.VendorAddressId

      this.api.delete(this.api.$.FundingInvoiceAndApSetting.deleteFundingAddress + '/' + id, id)
        .then(r => success())
        .catch(e => fail('Something went wrong. Cannot delete the Funding Address'))
    },

    removeMultipleFundingAddresses(payload) {
      var ids = []

      payload.rows.forEach(element => {
        ids.push(element.data.VendorAddressId)
      })
      var param = {
        IDs: ids
      }

      this.api.post(this.api.$.FundingInvoiceAndApSetting.deleteFundingAddresses, param)
        .then(r => this.validateDeleteFundingAddresses(r))
    },

    validateDeleteFundingAddresses(r) {
      if (r.data.Errors.length !== 0) {
        alert('Something went wrong. Cannot delete the Funding Addresses.')
      }
      this.refreshTable()
    },

    refreshTable() {
      this.$refs.FundingAddressesGrid.quickSearch()
      this.$refs.FundingAddressesGrid.onSelectAll(false)
    },
    onSave() {
      this.showAddEditAddress = false
      this.refreshTable()
    }
  }
}

</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/_modules/FundingInvoiceAndAPSettings/FundingAddresses/index.vue